<svg xmlns="http://www.w3.org/2000/svg" width="32" height="26" viewBox="0 0 32 26">
  <g id="Group_2_Copy_11" data-name="Group 2 Copy 11" transform="translate(0.335)">
    <rect id="Rectangle" width="32" height="26" rx="1.6" transform="translate(-0.335)" fill="#c7cfff"/>
    <path id="Rectangle-2" data-name="Rectangle" d="M1.6,0H30.4A1.6,1.6,0,0,1,32,1.6V3.2a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1.6A1.6,1.6,0,0,1,1.6,0Z" transform="translate(-0.335)" fill="#4562ff"/>
    <text id="_" data-name="₾" transform="translate(15.665 20)" fill="#4562ff" font-size="16" font-family="NotoSansGeorgian-SemiBold, Noto Sans Georgian" font-weight="600"><tspan x="-6" y="0">₾</tspan></text>
  </g>
</svg>
